export enum Product {
	PRIVATE_CAR = 'PRIVATE_CAR',
	COMMERCIAL_VEHICLE = 'COMMERCIAL_VEHICLE',
	SHORT_TERM = 'SHORT_TERM',
	TELEMATICS = 'TELEMATICS',
	TAXI = 'TAXI',
	CARROT = 'CARROT',
	STREET_COVER = 'STREET_COVER',
	SUBSCRIPTION = 'SUBSCRIPTION', // TODO: Remove when fixed documents method
	HOUSEHOLD = 'HOUSEHOLD',
}
export type Company = 'ACORN' | 'MOTORCADE' | 'CARROT' | 'FLAG' | 'MYPOLICY' | 'STREETCOVER';

export enum CoverLevel {
	TPO = 'TPO',
	TPFT = 'TPFT',
	COMP = 'COMP',
}
export enum BadgeType {
	PRIVATE_HIRE = '15',
	PUBLIC_HIRE = '17',
}

export enum PortalSection {
	MTA = 'MTA',
	RENEWAL = 'RENEWAL',
	PAY_NOW = 'PAY_NOW',
}

export enum TelematicDeviceProvider {
	THINGCO = 'ThingCo',
	IMS = 'IMS',
	HDEN_SELF_FIT = 'Howden',
	TRAKM8 = 'TrakM8',
}

export enum KeyCareUnderwriter {
	AGEAS = 'Ageas Insurance Limited',
	AA = 'AA Underwriting Insurance Company Limited',
}

/**
 * Acorn scheme types
 */
export const AcornSchemes = [
	'AcornInsurePC_v2',
	'AcorninsurePC',
	'Acorn30DayPC',
	'AcornInsureCV',
	'30DayPC',
	'Acorn30DayCV',
	'AcorninsurePC_PreProd',
	'AcornInsureCV_PreProd',
	'Acorn30DayPC_PreProd',
	'Acorn30DayCV_PreProd',
	'AcornProtect',
	'AcornProtectYD',
	'AcornTX',
	'Acorn7DayTX',
	'Acorn30DayTX',
	'Acorn90DayTX',
	'Acorn6MTX',
] as const satisfies readonly string[];
export type AcornSchemeType = (typeof AcornSchemes)[number];
/**
 * Motorcade scheme types
 */
export const MotorcadeSchemes = [
	'MotorcadeNF',
	'MotorcadePC',
	'MotorcadePC (RATES)',
	'MotorcadeCV_v2',
	'30 Day Test V2',
	'MotorcadeCV',
	'MotorcadePC_PreProd',
	'MotorcadeCV_PreProd',
] as const satisfies readonly string[];
export type MotorcadeSchemeType = (typeof MotorcadeSchemes)[number];

/**
 * Carrot scheme types
 */
export const CarrotSchemes = ['CarrotYD', 'CarrotTD'] as const satisfies readonly string[];
export type CarrotSchemeType = (typeof CarrotSchemes)[number];

/**
 * Flag scheme types
 */
export type FlagSchemeType = 'FlagTX';

/**
 * MyPolicy scheme types
 */
export const MyPolicySchemes = ['MyPolicyTD', 'MyPolicyYD'] as const satisfies readonly string[];
export type MyPolicySchemeType = (typeof MyPolicySchemes)[number];

/**
 * StreetCover scheme types
 */
export const StreetCoverSchemes = ['StreetCover30Day', 'StreetCoverAnnual'] as const satisfies readonly string[];
export type StreetCoverSchemeType = (typeof StreetCoverSchemes)[number];

/**
 * Type definition for scheme types.
 * Represents the valid scheme identifiers as enum values (string literals).
 * Uses enum values instead of enum keys to match the actual string values used in the system.
 */
// export type SchemeType = keyof typeof Scheme;
export type SchemeType =
	| AcornSchemeType
	| MotorcadeSchemeType
	| CarrotSchemeType
	| FlagSchemeType
	| MyPolicySchemeType
	| StreetCoverSchemeType;

export default {};
